import { createSvgIcon } from '@mui/material';
import Styled from "./custom-styled-icon";

export const EyeOff = Styled(
  createSvgIcon(
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.68668 6.31328L6.31334 9.68661C5.88001 9.25328 5.61334 8.65995 5.61334 7.99995C5.61334 6.67995 6.68001 5.61328 8.00001 5.61328C8.66001 5.61328 9.25334 5.87995 9.68668 6.31328Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.88 3.84669C10.7133 2.96669 9.37999 2.48669 7.99999 2.48669C5.64665 2.48669 3.45332 3.87336 1.92665 6.27336C1.32665 7.21336 1.32665 8.79336 1.92665 9.73336C2.45332 10.56 3.06665 11.2734 3.73332 11.8467"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.61334 13.02C6.37334 13.34 7.18001 13.5133 8.00001 13.5133C10.3533 13.5133 12.5467 12.1266 14.0733 9.72662C14.6733 8.78662 14.6733 7.20662 14.0733 6.26662C13.8533 5.91995 13.6133 5.59329 13.3667 5.28662"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.34 8.46667C10.1667 9.40668 9.39999 10.1733 8.45999 10.3467"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.31334 9.68665L1.33334 14.6666"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.6667 1.33337L9.68668 6.31337"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>,
    "EyeOff",
  ),
);

export default EyeOff;
